import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NbComponentType, NbWindowService} from '@nebular/theme';
import {Catalog, CatalogWithAncestors} from 'compob2b-libs';
import {translations} from '../../../environments/translations.ru';
import {ChooseCatalogModalComponent} from '../choose-catalog-modal/choose-catalog-modal.component';

interface ContextType {
  catalogChosenEvent: EventEmitter<CatalogWithAncestors>;
  removeCatalogEvent: EventEmitter<CatalogWithAncestors>;
  chosenCatalogs?: Catalog[];
  onlyOneSelection?: boolean;
  chooseOnlyLastLevel?: boolean;
  excludeCatalogIds?: number[];
}

@Component({
  selector: 'app-choose-catalog-input',
  templateUrl: './choose-catalog-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseCatalogInputComponent {
  modalComponent: NbComponentType = ChooseCatalogModalComponent;

  @Output() catalogChosenEvent = new EventEmitter<CatalogWithAncestors>();
  @Output() removeCatalogEvent = new EventEmitter<CatalogWithAncestors>();
  @Input() onlyOneSelection: boolean = null;
  @Input() chooseOnlyLastLevel: boolean = null;
  @Input() title: string = translations.selectOneCatalog;
  @Input() header: string;
  @Input() chosenCatalogs: Catalog[] = [];
  @Input() excludeCatalogIds: number[] = [];

  constructor(protected readonly windowService: NbWindowService) {
  }

  openChooseCatalogModal(): void {
    const data: ContextType = {
      catalogChosenEvent: this.catalogChosenEvent,
      removeCatalogEvent: this.removeCatalogEvent,
      chosenCatalogs: this.chosenCatalogs,
      excludeCatalogIds: this.excludeCatalogIds,
    };

    if (this.onlyOneSelection !== null) {
      data.onlyOneSelection = this.onlyOneSelection;
    }

    if (this.chooseOnlyLastLevel !== null) {
      data.chooseOnlyLastLevel = this.chooseOnlyLastLevel;
    }

    this.windowService.open(this.modalComponent, {
      context: data,
      title: this.title
    });
  }
}
